interface Env {
  DELIVERY_FEE: number
  CMS_API_URL: string
  MOBI_API_URL: string
  NETWORK_COVERAGE_URL: string
  MCOMMERCE_URL: string
  IMG_URL: string
  DOMAIN: string
  GOOGLE_MAP_API_KEY: string
  BRAND_GUIDE_URL: string
  BACKEND_URL: string
  GA_MEASUREMENT_ID: string
}

interface SystemEnv {
  production: Env
  development: Env
  test: Env
  staging: Env
}

const getGoogleMapsApiKey = (): string => {
  const primaryValue = process.env.NEXT_PUBLIC_GOOGLE_MAP_API_KEY
  if (typeof primaryValue === 'string' && primaryValue.length > 0) {
    return primaryValue
  }

  const fallbackValue = process.env.NEXT_PUBLIC_MAPS_BROWSER_KEY
  if (typeof fallbackValue === 'string' && fallbackValue.length > 0) {
    return fallbackValue
  }

  return ''
}

const SYSTEM_ENV: SystemEnv = {
  production: {
    DELIVERY_FEE: 2000,
    CMS_API_URL: 'https://osa.mobicom.mn/api',
    MOBI_API_URL: 'https://www.mobicom.mn/mobiapi',
    MCOMMERCE_URL: 'https://osa.mobicom.mn/m-commerce-rest/rest',
    // IMG_URL: 'https://osa.mobicom.mn/content/mcommerce',
    // IMG_URL: 'https://blob.blob.ub.cloud.mobinet.mn/blob/content/mcommerce',
    IMG_URL: 'https://webstatic.mobicom.mn/content/mcommerce',
    DOMAIN: 'https://www.mobicom.mn',
    NETWORK_COVERAGE_URL: 'https://osa.mobicom.mn/content/NetworkCoverageFiles',
    GOOGLE_MAP_API_KEY: getGoogleMapsApiKey(),
    BRAND_GUIDE_URL: 'https://osa.mobicom.mn/content/logo',
    BACKEND_URL: 'https://www.mobicom.mn/promoapi',
    GA_MEASUREMENT_ID: 'G-2B5NK0B4SG'
  },
  staging: {
    DELIVERY_FEE: 2000,
    CMS_API_URL: 'https://osa.mobicom.mn/api',
    MOBI_API_URL: 'https://staging-web.mobicom.mn/mobiapi',
    MCOMMERCE_URL: 'https://osa.mobicom.mn/m-commerce-rest/rest',
    // IMG_URL: 'https://blob.blob.ub.cloud.mobinet.mn/blob/content/mcommerce',
    IMG_URL: 'https://webstatic.mobicom.mn/content/mcommerce',
    DOMAIN: 'https://staging-web.mobicom.mn',
    NETWORK_COVERAGE_URL: 'https://osa.mobicom.mn/content/NetworkCoverageFiles',
    GOOGLE_MAP_API_KEY: getGoogleMapsApiKey(),
    BRAND_GUIDE_URL: 'https://osa.mobicom.mn/content/logo',
    BACKEND_URL: 'https://staging-web.mobicom.mn/promoapi',
    GA_MEASUREMENT_ID: 'G-2B5NK0B4SG'
  },
  test: {
    DELIVERY_FEE: 2000,
    CMS_API_URL: 'https://osa.mobicom.mn/api',
    MOBI_API_URL: 'https://dev-web.mobicom.mn/mobiapi',
    MCOMMERCE_URL: 'https://z-osa.mobicom.mn/m-commerce-rest/rest',
    // IMG_URL: 'https://blob.blob.ub.cloud.mobinet.mn/blob/content/mcommerce',
    IMG_URL: 'https://webstatic.mobicom.mn/content/mcommerce',
    DOMAIN: 'https://test-web.mobicom.mn',
    NETWORK_COVERAGE_URL: 'https://osa.mobicom.mn/content/NetworkCoverageFiles',
    GOOGLE_MAP_API_KEY: getGoogleMapsApiKey(),
    BRAND_GUIDE_URL: 'https://z-osa.mobicom.mn/content/logo',
    BACKEND_URL: 'https://dev-web.mobicom.mn/promoapi',
    GA_MEASUREMENT_ID: 'G-2B5NK0B4SG'
  },
  development: {
    DELIVERY_FEE: 2000,
    CMS_API_URL: 'https://z-osa.mobicom.mn/api',
    MOBI_API_URL: 'https://dev-web.mobicom.mn/mobiapi',
    // MOBI_API_URL: 'https://tourist-mobiwebapi.apps.dev.khangai2.k8s/mobiapi',
    MCOMMERCE_URL: 'https://z-osa.mobicom.mn/m-commerce-rest/rest',
    // IMG_URL: 'https://blob.blob.ub.cloud.mobinet.mn/blob/content/mcommerce',
    IMG_URL: 'https://webstatic.mobicom.mn/content/mcommerce',
    DOMAIN: 'https://dev-web.mobicom.mn',
    // DOMAIN: 'https://tourist-mobiwebapi.apps.dev.khangai2.k8s',
    NETWORK_COVERAGE_URL: 'https://osa.mobicom.mn/content/NetworkCoverageFiles',
    GOOGLE_MAP_API_KEY: getGoogleMapsApiKey(),
    BRAND_GUIDE_URL: 'https://z-osa.mobicom.mn/content/logo',
    BACKEND_URL: 'https://dev-web.mobicom.mn/promoapi',
    GA_MEASUREMENT_ID: 'G-2B5NK0B4SG'
  }
}
export const getSystemEnv = (): Env => {
  const env = process.env.NEXT_PUBLIC_APP_WORKING_ENV
  // const env = process.env.APP_WORKING_ENV || 'production'

  if (env === 'production') {
    return SYSTEM_ENV.production
  } else if (env === 'staging') {
    return SYSTEM_ENV.staging
  } else if (env === 'test') {
    return SYSTEM_ENV.test
  } else if (env === 'development') {
    return SYSTEM_ENV.development
  } else {
    return SYSTEM_ENV.production
  }
  // return SYSTEM_ENV[process.env.NODE_ENV]
  // return SYSTEM_ENV.development
  // return SYSTEM_ENV.production
}
